import React from 'react';
import PropTypes from 'prop-types';
import tagNameStyles from './TagName.style';

export default function TagName(props) {
	const { value = [] } = props;
	const classes = tagNameStyles();
	return (
		<>
			{value.map((item) => {
				return (
					<span key={item} className={classes.span}>
						{item}
					</span>
				);
			})}
		</>
	);
}

TagName.propTypes = {
	value: PropTypes.array
};
